export default __webpack_public_path__ + "static/media/user-dummy-pic1.5845b858.png";